(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["blog-template"] && !Shopify.designMode) return;
  try {
    
(function () {
  'use strict';

  function initBlogCategoryFilter(scope) {
    if (scope.dataset.filterInitialized === 'true') return;
    scope.dataset.filterInitialized = 'true';

    var nav        = scope.querySelector('.blog-category-filter');
    var cards      = Array.prototype.slice.call(scope.querySelectorAll('.entry-summary'));
    var emptyState = scope.querySelector('.blog-category-filter__empty');
    var pagination = scope.querySelector('.blog-pagination');
    var pageSize   = parseInt(scope.dataset.pageSize, 10) || 8;
    var buttons    = nav ? Array.prototype.slice.call(nav.querySelectorAll('.blog-category-filter__btn')) : [];

    var state = { category: buttons.length ? (buttons[0].getAttribute('data-category') || '') : '', page: 1 };

    /* ── Cards matching the current category filter ── */
    function getMatches() {
      return cards.filter(function (card) {
        return card.getAttribute('data-category') === state.category;
      });
    }

    /* ── Build a windowed page-number list, e.g. 1 … 4 5 6 … 12 ── */
    function getPageWindow(current, total) {
      if (total <= 7) {
        var all = [];
        for (var i = 1; i <= total; i++) all.push(i);
        return all;
      }
      var pages = [1];
      if (current > 3) pages.push('…');
      var start = Math.max(2, current - 1);
      var end = Math.min(total - 1, current + 1);
      for (var p = start; p <= end; p++) pages.push(p);
      if (current < total - 2) pages.push('…');
      pages.push(total);
      return pages;
    }

    function renderPagination(totalPages) {
      if (!pagination) return;

      if (totalPages <= 1) {
        pagination.hidden = true;
        pagination.innerHTML = '';
        return;
      }

      pagination.hidden = false;

      var html = '<button type="button" class="blog-pagination__btn blog-pagination__btn--prev"' +
        (state.page === 1 ? ' disabled' : '') + '>&lsaquo; Prev</button>';

      html += '<div class="blog-pagination__pages">';
      getPageWindow(state.page, totalPages).forEach(function (p) {
        if (p === '…') {
          html += '<span class="blog-pagination__page is-ellipsis">…</span>';
        } else if (p === state.page) {
          html += '<span class="blog-pagination__page is-current" aria-current="page">' + p + '</span>';
        } else {
          html += '<button type="button" class="blog-pagination__page" data-page="' + p + '">' + p + '</button>';
        }
      });
      html += '</div>';

      html += '<button type="button" class="blog-pagination__btn blog-pagination__btn--next"' +
        (state.page === totalPages ? ' disabled' : '') + '>Next &rsaquo;</button>';

      pagination.innerHTML = html;

      var prevBtn = pagination.querySelector('.blog-pagination__btn--prev');
      var nextBtn = pagination.querySelector('.blog-pagination__btn--next');
      if (prevBtn) prevBtn.addEventListener('click', function () { goToPage(state.page - 1); });
      if (nextBtn) nextBtn.addEventListener('click', function () { goToPage(state.page + 1); });

      Array.prototype.slice.call(pagination.querySelectorAll('.blog-pagination__page[data-page]')).forEach(function (btn) {
        btn.addEventListener('click', function () {
          goToPage(parseInt(btn.getAttribute('data-page'), 10));
        });
      });
    }

    function goToPage(page) {
      state.page = page;
      render();
      scope.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }

    /* ── Recalculate + repaint against the current filter + page state ── */
    function render() {
      var matches = getMatches();
      var totalPages = Math.max(1, Math.ceil(matches.length / pageSize));
      if (state.page > totalPages) state.page = totalPages;

      var start = (state.page - 1) * pageSize;
      var visibleSet = matches.slice(start, start + pageSize);

      cards.forEach(function (card) {
        card.hidden = visibleSet.indexOf(card) === -1;
      });

      if (emptyState) emptyState.classList.toggle('is-visible', matches.length === 0);
      renderPagination(totalPages);
    }

    /* ── Category tabs (single-select) ── */
    buttons.forEach(function (button) {
      button.addEventListener('click', function () {
        state.category = button.getAttribute('data-category') || '';
        state.page = 1;
        buttons.forEach(function (b) {
          var isActive = b === button;
          b.classList.toggle('router-link-active', isActive);
          b.setAttribute('aria-pressed', isActive ? 'true' : 'false');
        });
        render();
      });
    });

    render();
  }

  function initAll(root) {
    var scopes = (root || document).querySelectorAll('.blog-category-filter-scope');
    scopes.forEach(function (scope) {
      initBlogCategoryFilter(scope);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initAll(document);
    });
  } else {
    initAll(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nws-alt-blog-post"] && !Shopify.designMode) return;
  try {
    
(function () {
  'use strict';

  function initAltBlogPagination(scope) {
    if (scope.dataset.pagerInitialized === 'true') return;
    scope.dataset.pagerInitialized = 'true';

    var cards      = Array.prototype.slice.call(scope.querySelectorAll('.nws-alt-blog-card'));
    var pagination = scope.querySelector('.nws-alt-blog-pagination');
    var pageSize   = parseInt(scope.dataset.pageSize, 10) || 9;

    var state = { page: 1 };

    function getPageWindow(current, total) {
      if (total <= 7) {
        var all = [];
        for (var i = 1; i <= total; i++) all.push(i);
        return all;
      }
      var pages = [1];
      if (current > 3) pages.push('…');
      var start = Math.max(2, current - 1);
      var end = Math.min(total - 1, current + 1);
      for (var p = start; p <= end; p++) pages.push(p);
      if (current < total - 2) pages.push('…');
      pages.push(total);
      return pages;
    }

    function renderPagination(totalPages) {
      if (!pagination) return;

      if (totalPages <= 1) {
        pagination.hidden = true;
        pagination.innerHTML = '';
        return;
      }

      pagination.hidden = false;

      var html = '<button type="button" class="nws-alt-blog-pagination__btn nws-alt-blog-pagination__btn--prev"' +
        (state.page === 1 ? ' disabled' : '') + '>&lsaquo; Prev</button>';

      html += '<div class="nws-alt-blog-pagination__pages">';
      getPageWindow(state.page, totalPages).forEach(function (p) {
        if (p === '…') {
          html += '<span class="nws-alt-blog-pagination__page is-ellipsis">…</span>';
        } else if (p === state.page) {
          html += '<span class="nws-alt-blog-pagination__page is-current" aria-current="page">' + p + '</span>';
        } else {
          html += '<button type="button" class="nws-alt-blog-pagination__page" data-page="' + p + '">' + p + '</button>';
        }
      });
      html += '</div>';

      html += '<button type="button" class="nws-alt-blog-pagination__btn nws-alt-blog-pagination__btn--next"' +
        (state.page === totalPages ? ' disabled' : '') + '>Next &rsaquo;</button>';

      pagination.innerHTML = html;

      var prevBtn = pagination.querySelector('.nws-alt-blog-pagination__btn--prev');
      var nextBtn = pagination.querySelector('.nws-alt-blog-pagination__btn--next');
      if (prevBtn) prevBtn.addEventListener('click', function () { goToPage(state.page - 1); });
      if (nextBtn) nextBtn.addEventListener('click', function () { goToPage(state.page + 1); });

      Array.prototype.slice.call(pagination.querySelectorAll('.nws-alt-blog-pagination__page[data-page]')).forEach(function (btn) {
        btn.addEventListener('click', function () {
          goToPage(parseInt(btn.getAttribute('data-page'), 10));
        });
      });
    }

    function goToPage(page) {
      state.page = page;
      render();
      scope.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }

    function render() {
      var totalPages = Math.max(1, Math.ceil(cards.length / pageSize));
      if (state.page > totalPages) state.page = totalPages;

      var start = (state.page - 1) * pageSize;
      var end = start + pageSize;

      cards.forEach(function (card, index) {
        card.hidden = index < start || index >= end;
      });

      renderPagination(totalPages);
    }

    render();
  }

  function initAll(root) {
    var scopes = (root || document).querySelectorAll('.nws-alt-blog-scope');
    scopes.forEach(function (scope) {
      initAltBlogPagination(scope);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initAll(document);
    });
  } else {
    initAll(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nws-featured-blog-post"] && !Shopify.designMode) return;
  try {
    
(function () {
  'use strict';

  function initFurtherPosts(scope) {
    if (scope.dataset.pagerInitialized === 'true') return;
    scope.dataset.pagerInitialized = 'true';

    var cards      = Array.prototype.slice.call(scope.querySelectorAll('.nws-grid-item'));
    var pagination = scope.querySelector('.nws-grid-pagination');
    var pageSize   = parseInt(scope.dataset.pageSize, 10) || 9;

    var state = { page: 1 };

    function getPageWindow(current, total) {
      if (total <= 7) {
        var all = [];
        for (var i = 1; i <= total; i++) all.push(i);
        return all;
      }
      var pages = [1];
      if (current > 3) pages.push('…');
      var start = Math.max(2, current - 1);
      var end = Math.min(total - 1, current + 1);
      for (var p = start; p <= end; p++) pages.push(p);
      if (current < total - 2) pages.push('…');
      pages.push(total);
      return pages;
    }

    function renderPagination(totalPages) {
      if (!pagination) return;

      if (totalPages <= 1) {
        pagination.hidden = true;
        pagination.innerHTML = '';
        return;
      }

      pagination.hidden = false;

      var html = '<button type="button" class="nws-grid-pagination__btn nws-grid-pagination__btn--prev"' +
        (state.page === 1 ? ' disabled' : '') + '>&lsaquo; Prev</button>';

      html += '<div class="nws-grid-pagination__pages">';
      getPageWindow(state.page, totalPages).forEach(function (p) {
        if (p === '…') {
          html += '<span class="nws-grid-pagination__page is-ellipsis">…</span>';
        } else if (p === state.page) {
          html += '<span class="nws-grid-pagination__page is-current" aria-current="page">' + p + '</span>';
        } else {
          html += '<button type="button" class="nws-grid-pagination__page" data-page="' + p + '">' + p + '</button>';
        }
      });
      html += '</div>';

      html += '<button type="button" class="nws-grid-pagination__btn nws-grid-pagination__btn--next"' +
        (state.page === totalPages ? ' disabled' : '') + '>Next &rsaquo;</button>';

      pagination.innerHTML = html;

      var prevBtn = pagination.querySelector('.nws-grid-pagination__btn--prev');
      var nextBtn = pagination.querySelector('.nws-grid-pagination__btn--next');
      if (prevBtn) prevBtn.addEventListener('click', function () { goToPage(state.page - 1); });
      if (nextBtn) nextBtn.addEventListener('click', function () { goToPage(state.page + 1); });

      Array.prototype.slice.call(pagination.querySelectorAll('.nws-grid-pagination__page[data-page]')).forEach(function (btn) {
        btn.addEventListener('click', function () {
          goToPage(parseInt(btn.getAttribute('data-page'), 10));
        });
      });
    }

    function goToPage(page) {
      state.page = page;
      render();
      scope.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }

    function render() {
      var totalPages = Math.max(1, Math.ceil(cards.length / pageSize));
      if (state.page > totalPages) state.page = totalPages;

      var start = (state.page - 1) * pageSize;
      var end = start + pageSize;

      cards.forEach(function (card, index) {
        card.hidden = index < start || index >= end;
      });

      renderPagination(totalPages);
    }

    render();
  }

  function initAll(root) {
    var scopes = (root || document).querySelectorAll('.nws-further-posts-scope');
    scopes.forEach(function (scope) {
      initFurtherPosts(scope);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initAll(document);
    });
  } else {
    initAll(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["promo-fixed"]) return;
  try {
    
  function initPromoFixed(){
    var $ttpromofixed = $(".tt-promo-fixed"),
    	$promofixeddata = $(".promofixeddata"),
        $promofixedclose = $ttpromofixed.find(".tt-btn-close");
    
    if($('html').hasClass('touch-device') && $ttpromofixed.hasClass('hidden-mobile')) return false;
	if($ttpromofixed.hasClass('hidden-mobile') && $(window).width < 1025) return false;
    if($promofixeddata.length == 0) return false;
    
    setPromoFixedItem($ttpromofixed, $promofixeddata);
	showPromoFixed($ttpromofixed, $ttpromofixed.data('start'));
    
	showPromoFixedNextMessage($ttpromofixed, $promofixeddata, $promofixedclose)

    $promofixedclose.click(function(){
      $ttpromofixed.addClass('nonevent').fadeTo(100, 0);
    });
  }
  function showPromoFixedNextMessage($modal, $data, $close){
    var nextmin = $modal.data('min'),
        nextmax = $modal.data('max');
	var i = getRndInteger(nextmin, nextmax);
    setTimeout(function(){
      $close.trigger('click');
      setTimeout(function(){
        setPromoFixedItem($modal, $data);
        showPromoFixed($modal, 0);
        showPromoFixedNextMessage($modal, $data, $close);
      }, 100);
    }, i);
  }
  function getPromoFixedCustomProductIndex($promofixeddata){
    var min = 0,
        max = $promofixeddata.children().length;
    return getRndInteger(min, max);
  }
  function setPromoFixedItem($modal, $data){
    var i = getPromoFixedCustomProductIndex($data)
    var data = $data.children().eq(i);
    $modal.find('.tt-img').find('a').attr('href', data.data('url')).find('img').attr('src', data.data('image')).attr('alt', data.data('alt'));
    $modal.find('.pr_name').attr('href', data.data('url')).text(data.data('name'));
    
    var nummin = parseInt(data.data('min')),
    	nummax = parseInt(data.data('max')),
    	num = getRndInteger(nummin, nummax);
    $modal.find('.tt-info-value').text(num);

	if (typeof data.data('text') === typeof undefined) return false;
    var str = data.data('text').split('||'),
    	i = getRndInteger(0, str.length-1);
    $modal.find('.tt-info-text').text(str[i]);
  }
  function showPromoFixed($parent, delay){
    setTimeout(function(){
	  $parent.removeClass('nonevent').fadeTo(300, 1);
    }, delay);
  }
  function getRndInteger(min, max) {
    return Math.floor(Math.random() * (max - min) ) + min;
  }
  setTimeout(initPromoFixed, 300);

  } catch(e) { console.error(e); }
})();
})();
